import React from 'react';
import { Paper } from '@mui/material';
import { actions } from 'redux/actions';
import { setLanguage, _t, getCurrentLanguage } from 'utils';
import Form from 'screens/shared/form';
import { VALIDATION, LANGUAGE } from 'constant';
import { getConfig } from 'utils/config';
import { getAssets } from 'themes/assets';
import { formField } from 'types';

export default ({ history }) => {
  const config = getConfig();
  const assets = getAssets();
  // eslint-disable-next-line max-len
  const forgotPasswordLabel = <a className="flex width-320 flex-justify-end color-link f-12 no-underline" href="https://dcd.ionos.com/password-recovery/">{_t('Forgot password?')}</a>;

  const fields = [
    formField.text({ name: 'email', title: _t('Email') }),
    formField.password({ name: 'password', title: _t('Password') }),
  ];

  if (config?.loginScreen?.isForgotPassword) fields.push(formField.label({ name: 'label', title: forgotPasswordLabel }));

  const validations = [
    { name: 'email', type: VALIDATION.REQUIRED },
    { name: 'email', type: VALIDATION.EMAIL },
    { name: 'password', type: VALIDATION.REQUIRED },
  ];

  const loginHandler = ({ email, password }) => {
    actions.identity.login({ email, password, history });
  };

  const enterKeyHandler = () => {
    document.querySelector('.form-footer button').click();
  };

  const langChangeHandler = (lang) => {
    setLanguage(lang);
    window.location.reload();
  };

  return (
    <section className="screen-login">
      <img src={assets.LOGO} alt="Logo" className="logo" />
      <span className="beta-icon-login">BETA</span>

      {!!config?.loginScreen?.isLanguage && (
        <div className="flex flex-justify-end f-10 margin-auto max-width-350 color-text p-3">
          <span className={`cursor ${getCurrentLanguage() !== LANGUAGE.DE ? 'opacity-6' : ''}`} onClick={() => langChangeHandler(LANGUAGE.DE)}>DE</span>
          <span className="m-l-5 m-r-5 opacity-6">/</span>
          <span className={`cursor ${getCurrentLanguage() !== LANGUAGE.EN ? 'opacity-6' : ''}`} onClick={() => langChangeHandler(LANGUAGE.EN)}>EN</span>
        </div>
      )}

      <Paper onKeyUp={({ key }) => key === 'Enter' && enterKeyHandler()} className="relative">
        <h2 className="text-base-color">{_t('Login')}</h2>
        <Form
          fields={fields}
          fieldsValues={{ email: '', password: '' }}
          onSubmit={loginHandler}
          submitTitle={_t('Login')}
          isCancel={false}
          validations={validations}
        />
        {!!config?.loginScreen?.isSignup && (
          <a className="absolute bottom-25 color-gray f-14 no-underline" href="https://cloud.ionos.com/compute/signup">{_t('Start Free Trail')}</a>
        )}
      </Paper>

      <div className="flex flex-justify-between f-12 margin-auto max-width-350 color-text p-3 m-t-2">
        {!!config?.loginScreen?.isVersion && <span className="color-text opacity-5">{`Version: ${process.env.REACT_APP_VERSION}`}</span>}
        {!!config?.loginScreen?.isImprint && <a className="cursor color-text opacity-5" href="https://www.ionos.de/impressum">{_t('Imprint')}</a>}
      </div>

      <div className="copyright">
        <p>{config?.settings?.copyright}</p>
      </div>
    </section>
  );
};
